import Glide from '@glidejs/glide';
import Sizes from '../../../components/shared/glide_fixed_width_slides';

const options = {
  type: 'carousel',
  startAt: 0,
  perView: 4,
  slideWidth: 243,
  gap: 23,
  peek: {
    before: 0,
    after: 0,
  },
  breakpoints: {
    320: {
      type: 'carousel',
      perView: 1.2,
    },
  },
};

document
  .querySelectorAll('.marketplace-related-articles__posts.glide')
  .forEach((el) => {
    const cardsGlider = new Glide(el, options);
    cardsGlider.mount(Sizes);
  });
